import React from 'react'
import { CircularProgress, Grid } from '@material-ui/core'

const Spinner: React.FC = () => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
    style={{ minHeight: '100vh' }}
  >
    <Grid item xs={3}>
      <CircularProgress color="primary" />
    </Grid>
  </Grid>
)

export default Spinner
